<template>
    <div class="bg-a-brown-e1d2bc rounded-10 h-50px py-2 px-4">
        <div class="text-12 text-a-brown-9f8273">{{label}}</div>
        <div class="text-16 text-a-brown-502314">
            <slot></slot>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        label: { type: String, required: true },
    },
}
</script>
<style lang="scss" scoped>
</style>
